import type { MessageEnvelopeAny } from './messageCryptoTypes';

export const DEV_PLAIN_ALGORITHM = 'DEV-PLAINTEXT-BASE64';
export const DEV_PLAIN_NONCE = 'dev-plain';

export function utf8ToBase64Compat(input: string): string {
  const bytes = new TextEncoder().encode(input);
  let binary = '';
  for (const b of bytes) binary += String.fromCharCode(b);
  return btoa(binary);
}

export function base64ToUtf8Compat(input: string): string {
  const raw = String(input || '');
  if (!raw) return '';

  const binary = atob(raw);
  const bytes = Uint8Array.from(binary, ch => ch.charCodeAt(0));

  try {
    return new TextDecoder().decode(bytes);
  } catch {
    return binary;
  }
}

export function createDevPlainEnvelopeForWeb(text: string): MessageEnvelopeAny {
  return {
    version: 1,
    algorithm: DEV_PLAIN_ALGORITHM,
    ciphertext: utf8ToBase64Compat(text),
    nonce: DEV_PLAIN_NONCE,
    senderKeyId: 'web-dev-plain',
  };
}

export function looksLikeDevPlainEnvelope(envelope?: MessageEnvelopeAny | null): boolean {
  if (!envelope) return false;

  const nonce = String(envelope.nonce || '');
  const senderKeyId = String(envelope.senderKeyId || envelope.sender_key_id || '');
  const algorithm = String(envelope.algorithm || '');

  return (
    nonce === DEV_PLAIN_NONCE ||
    senderKeyId === 'web-dev-plain' ||
    senderKeyId === 'mobile-dev-plain' ||
    algorithm === DEV_PLAIN_ALGORITHM
  );
}

export function decodeDevPlainEnvelope(envelope?: MessageEnvelopeAny | null): string {
  if (!looksLikeDevPlainEnvelope(envelope)) return '';

  try {
    return base64ToUtf8Compat(String(envelope?.ciphertext || ''));
  } catch {
    return '';
  }
}

export function normalizeEnvelopeLike(rowOrEnvelope: any): MessageEnvelopeAny {
  const envelope = rowOrEnvelope?.envelope || rowOrEnvelope || {};

  return {
    version: Number(envelope?.version || rowOrEnvelope?.crypto_version || 1),
    algorithm: String(envelope?.algorithm || rowOrEnvelope?.algorithm || ''),
    ciphertext: String(
      rowOrEnvelope?.cipherText ||
      rowOrEnvelope?.ciphertext ||
      rowOrEnvelope?.bodyCiphertext ||
      rowOrEnvelope?.body_ciphertext ||
      envelope?.ciphertext ||
      ''
    ),
    nonce: String(
      rowOrEnvelope?.iv ||
      rowOrEnvelope?.nonce ||
      rowOrEnvelope?.bodyNonce ||
      rowOrEnvelope?.body_nonce ||
      envelope?.nonce ||
      ''
    ),
    senderKeyId: String(
      rowOrEnvelope?.senderKeyId ||
      rowOrEnvelope?.sender_key_id ||
      envelope?.senderKeyId ||
      envelope?.sender_key_id ||
      ''
    ),
  };
}
